import { InnerContent } from '@/components/atoms/InnerContent/InnerContent';

const pluralise = (count: number, plural: any, singular: any) =>
  count === 1 ? singular : plural;

const featureMap: { [key: string]: any } = {
  bedCount: (beds: number) => ({
    description: `${beds} ${pluralise(beds, 'beds', 'bed')}`,
    icon: 'bed',
    iconSize: '2x',
    show: !!beds,
    disabled: false,
  }),
  doubleBedCount: (beds: number) => ({
    description: beds
      ? `${beds} ${pluralise(
          beds,
          'beds in double / twin rooms',
          'bed in a double / twin room',
        )}`
      : 'No double / twin rooms',
    icon: 'bed',
    iconSize: '2x',
    show: !!beds || beds === 0,
    disabled: beds === 0,
  }),
  enSuiteRoomCount: (enSuites?: number) => ({
    description: enSuites
      ? `${enSuites} en-suite ${pluralise(enSuites, 'rooms', 'room')}`
      : 'No en-suite rooms',
    icon: 'toilet',
    iconSize: '2x',
    show: !!enSuites || enSuites === 0,
    disabled: enSuites === 0,
  }),
  dateOpened: (dateOpened: any, purposeBuilt?: any) => ({
    iconSize: '2x',
    icon: 'hotel',
    description: `${
      purposeBuilt ? 'Purpose built, opened' : 'Opened'
    } in ${new Date(dateOpened).getFullYear()}`,
  }),
};

interface CareHomeFeaturesProps {
  careHomeFeatures: { [key: string]: any };
}
export const CareHomeFeatures = ({
  careHomeFeatures,
}: CareHomeFeaturesProps) => {
  const items = Object.entries(careHomeFeatures)
    .map((feature) => {
      const featureKey = feature[0];
      const featureValue = feature[1];

      if (featureKey === 'dateOpened') {
        return featureMap[featureKey](
          featureValue,
          careHomeFeatures.purposeBuilt,
        );
      }

      return featureMap[featureKey]?.(featureValue);
    })
    .filter((item) => item && item?.show !== false);

  return (
    <InnerContent
      size='md'
      items={items.map((item) => ({
        ...item,
        title: item.label,
        description: item.description,
        iconSize: item.iconSize || '1x',
        iconColor: item.color as any,
      }))}
    />
  );
};

export default CareHomeFeatures;
